import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

// Layouts
import { LayoutComponent } from './Layouts/layout/layout.component';

// App components
import { AppComponent } from './app.component';


// Pages
import { LoginComponent } from './pages/login/login.component';
import { ShowErrorsComponent } from './Component/show-errors/show-errors.component';
import { DemoComponent } from './pages/demo/demo.component';

import {SharedModuleModule} from './shared-module/shared-module.module';

// Custom Module
import { AppRoutingModule } from './app-routing.module';

// External Module
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { AppPaginationComponent } from './Component/app-pagination/app-pagination.component';
import { DownloadCertificateComponent } from './pages/download-certificate/download-certificate.component';
import { ColorPickerModule } from 'ngx-color-picker';


import { AuthService } from './auth/auth.service';
import { AuthGuard } from './auth/auth.guard';
import { SessionStorageService } from './services/session/sessionstorage.service';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';

@NgModule({
  declarations: [

    AppComponent,
    LoginComponent,
    LayoutComponent,
    DemoComponent,   
    DownloadCertificateComponent,
    UnauthorizedComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    SharedModuleModule,
    ColorPickerModule,  
     AppRoutingModule,
    NgbModule.forRoot()
  ],  
  providers: [AuthService, AuthGuard, SessionStorageService],
  bootstrap: [AppComponent],
  entryComponents: [AppComponent],

})
export class AppModule { }
